'use strict';

const uuid = require('uuid');
const _ = {
    find:       require('lodash/find'),
    forEach:    require('lodash/forEach'),
    isEqual:    require('lodash/isEqual'),
    includes:   require('lodash/includes'),
}

const Globals = require('../../../app/globals');

const ServerRequest = require('../actions/request');
const OrganizationStore = require('../stores/OrganizationStore');

// haiku: "anthropic.claude-3-haiku-20240307-v1:0",
// opus: "anthropic.claude-3-opus-20240229-v1:0",
// 3.5 sonnet: "anthropic.claude-3-5-sonnet-20240620-v1:0",
// const DEFAULT_MODEL_ID = "anthropic.claude-3-haiku-20240307-v1:0";
// const DEFAULT_MODEL_ID = "anthropic.claude-3-opus-20240229-v1:0";
// const DEFAULT_MODEL_ID = "anthropic.claude-3-5-sonnet-20240620-v1:0";
// const DEFAULT_MODEL_ID = "anthropic.claude-3-5-sonnet-20241022-v2:0";
// const DEFAULT_MODEL_ID = "anthropic.claude-sonnet-4-20250514-v1:0";
const DEFAULT_MODEL_ID = "anthropic.claude-sonnet-5";

// server automatically adds a "us." prefix to these ( inference profile ) 
const AVAILABLE_MODEL_IDS = [
    "anthropic.claude-haiku-4-5-20251001-v1:0",
    "anthropic.claude-sonnet-4-6",
    "anthropic.claude-sonnet-5",
    "anthropic.claude-opus-4-6-v1",
    "anthropic.claude-opus-4-8",
    "anthropic.claude-opus-5",
    // image models (duplicated below)
    "stability.sd3-5-large-v1:0",
];

//    "anthropic.claude-3-haiku-20240307-v1:0",
//    "anthropic.claude-3-5-haiku-20241022-v1:0",
//    "anthropic.claude-3-5-sonnet-20240620-v1:0",
//    "anthropic.claude-3-5-sonnet-20241022-v2:0",
//    "anthropic.claude-3-7-sonnet-20250219-v1:0",
//    "anthropic.claude-sonnet-4-20250514-v1:0",
//    "anthropic.claude-sonnet-4-5-20250929-v1:0",
//    "anthropic.claude-3-opus-20240229-v1:0",
//    "amazon.nova-pro-v1:0",


const AVAILABLE_IMG_MODEL_IDS = [
//    "amazon.nova-canvas-v1:0",
    "stability.sd3-5-large-v1:0",
];

// const DEFAULT_IMG_MODEL_ID = "amazon.nova-canvas-v1:0";
const DEFAULT_IMG_MODEL_ID = "stability.sd3-5-large-v1:0";

const MESSAGE_TYPES = {
    // incoming
    chatbot_request: 'mzl-chatbot-request',
    chatbot_get_template_boilerplate: 'mzl-chatbot-get-template-boilerplate',
    chatbot_set_template_boilerplate_value: 'mzl-chatbot-set-template-boilerplate-value',
    chatbot_get_available_models: 'mzl-chatbot-get-available-models',
    chatbot_get_latest_playbooks: 'mzl-chatbot-get-latest-playbooks',
    img_gen_request: 'mzl-img-gen-request',
    img_gen_get_available_models: 'mzl-img-gen-get-available-models',
    agent_request: 'mzl-agent-request',

    // combined - incoming to create the playbook, outgoing for the result / error
    chatbot_create_playbook: 'mzl-chatbot-create-playbook',
    chatbot_publish_playbook: 'mzl-chatbot-publish-playbook',
    chatbot_update_playbook_string_key: 'mzl-chatbot-update-playbook-string-key',
    chatbot_update_playbook_string_keys: 'mzl-chatbot-update-playbook-string-keys',
    chatbot_update_playbook_models: 'mzl-chatbot-update-playbook-models',
    
    // outgoing
    chatbot_result: 'mzl-chatbot-result',
    chatbot_error: 'mzl-chatbot-error',
    chatbot_template_boilerplate: 'mzl-chatbot-template-boilerplate',
    chatbot_set_template_boilerplate_value_result: 'mzl-chatbot-set-template-boilerplate-value-result',
    chatbot_available_models: 'mzl-chatbot-available-models',
    chatbot_latest_playbooks: 'mzl-chatbot-latest-playbooks',
    img_gen_result: 'mzl-img-gen-result',
    img_gen_error: 'mzl-img-gen-error',
    img_gen_available_models: 'mzl-img-gen-available-models',
    agent_result: 'mzl-agent-result',
    agent_error: 'mzl-agent-error',
};


function checkAwsStickyCookie() {
    // Get the document cookie string
    const cookies = document.cookie;

    // Check for the presence of AWS ALB or ELB cookies
    const isALBCookiePresent = cookies.includes("AWSALB") || cookies.includes("AWSALBCORS");
    // const isELBCookiePresent = cookies.includes("AWSELB");

    if (isALBCookiePresent) { //  || isELBCookiePresent) {
        console.log("An AWS sticky session cookie is enabled and present.");
        return true;
    } 
    console.log("No AWS sticky session cookie found.");
    return false;
}    

// utility class to help forge client communicate 
// with an app template in an iframe
// for Chatbot system
class ChatbotSystem {
    constructor(props) {
        this.unsubscribes = []; // for future use
        this.pollTaskManager = new ServerRequest.PollTaskManager();

        let anonymous = false;
        let hasPermission = false;
        let usage;
        if (!props.userData) {
            console.log("ChatbotSystem missing userData"); // FIXME: remove debug spam
        }
        else {
            let permissions = props.userData.permissions || props.userData.account_permissions;
            if (permissions) {
                hasPermission = !!permissions[Globals.users.account_features.useChatBot];
            }
            usage = props.userData.usage;
        }
        if (!hasPermission) {
            switch(usage) {
                case Globals.SYSTEM_USAGE.ACTIVITY_EDIT:
                    if (props && props.userData && props.userData.admin) {
                        hasPermission = true; // allow muzzy lane internal use in editor
                    }
                    break;
                case Globals.SYSTEM_USAGE.ACTIVITY_PREVIEW:
                    hasPermission = true; // allow muzzy lane internal use in editor
                    break; // always allowed for now
                    
                case Globals.SYSTEM_USAGE.SHORT_COURSE_PLAY:
                    hasPermission = true; // allow muzzy lane internal use in editor
                    break; // always allowed for now

                    
                // case Globals.SYSTEM_USAGE.ASSIGNMENT:
                // case Globals.SYSTEM_USAGE.SHARE_LINK:
                default:
                    break;
            }
        }
        if (!hasPermission) {
            console.log("ChatbotSystem not allowed");
        }
        
        // build model parameter cases
        this.hasPermission = hasPermission;
        let modelParamCases = [];
        _.forEach(Globals.ai.useCases,(useCase)=>{
            let modelParams = Globals.ai.useCaseModelParams[useCase];
            modelParamCases.push({...modelParams, useCase});
        });
        this.modelParamCases = modelParamCases;

        let { channelId, activityId, shareId, shortCourseId } = props.userData;
        if (shareId) {
            anonymous = true;
        }
        if (!channelId) {
            console.log("ChatbotSystem missing channelId"); // FIXME: remove debug spam
        }
        else {
            if (!activityId && !shortCourseId) {
                console.log("ChatbotSystem missing activityId or shortCourseId"); // FIXME: remove debug spam
            }
            const orgStoreState = OrganizationStore.getStateOrganization(channelId); // in case we already have the data
            if (orgStoreState && orgStoreState.orgUserSettings && orgStoreState.orgUserSettings.custom_config) {
                let modelParamCases = orgStoreState.orgUserSettings.custom_config.modelParamCases;
                if (modelParamCases) {
                    this.modelParamCases = modelParamCases;
                }
            }
            else {
                ServerRequest.makeRequest(`/authoring/organization/${channelId}/settings_anon`, 'GET')
                .then((res)=>{
                    if (res && res.custom_config) {
                        let modelParamCases = res.custom_config.modelParamCases;
                        if (modelParamCases) {
                            console.log(`ChatbotSystem using custom modelParameters for org channel ${channelId}`);
                            this.modelParamCases = modelParamCases;
                        }
                    }
                    else {
                        console.log(`ChatbotSystem org channel ${channelId} did not have custom modelParemeters`);
                    }
                })
                .catch((err)=>{
                    console.log("ChatbotSystem error getting org settings",err);
                });
            }
        }
        this.anonymous = anonymous;
        this.usageData = {
            channelId: channelId || null,
            activityId: activityId || null,
            shareId: shareId || null,
            shortCourseId: shortCourseId || null,
        };
    }
    
    _handleChatbotRequest(targetWindow, msg) {
        if (!targetWindow) {
            console.error("ChatbotSystem needs target window");
            return;
        }
        
        //checkAwsStickyCookie(); // TEST
        
        this.targetWindow = targetWindow;
        let {request_id, systemText, userInput, priorHistory, modelId, modelParameters, useCase, timeLimitSeconds} = msg.data;

        if (!this.hasPermission) {
            let message = { type: MESSAGE_TYPES.chatbot_error, data: {request_id, error:new Error("not allowed")} };
            targetWindow.postMessage(message, '*');
            return;
        }
        
        let chatbotState = { systemText, textFromUser:userInput, messageHistory:priorHistory };
        let type = MESSAGE_TYPES.chatbot_result;
        
        if (useCase && !modelParameters) {
            // determine model parameters depending on use case
            modelParameters = _.find(this.modelParamCases,{useCase});
            if (modelParameters) {
                console.log(`Using modelParameters based on useCase: ${JSON.stringify(modelParameters)}`); // FIXME: remove debug spam
            }
            else {
                console.log(`Error: Did not find useCase: ${useCase}`);
            }
        }
        else if (modelParameters) {
            console.log(`Using specified modelParameters: ${JSON.stringify(modelParameters)}`); // FIXME: remove debug spam
        }
        
        if (!_.includes(AVAILABLE_MODEL_IDS,modelId)) {
            if (modelId) {
                console.error(`modelId ${modelId} not listed in AVAILABLE_MODEL_IDS.  Using default instead.`);
            }
            modelId = DEFAULT_MODEL_ID;
        } 
        let data = {...chatbotState, 
            modelId, 
            modelParameters,
            usageData: this.usageData
        };
        let url = this.anonymous ? `/authoring/interactive_chatbot_anon` : `/authoring/interactive_chatbot`;
        let postData = JSON.stringify(data);
        let jsonLimit = GlobalConfig.jsonUploadLimit || 1024*1024; // GlobalConfig.jsonUploadLimit doesn't currently exist, but nova-nodejs sets jsonBodyParser.limit to "1mb"
        if (postData.length > jsonLimit) {
            let message = { type: MESSAGE_TYPES.chatbot_error, data: {request_id, error: `payload length exceeds limit.  ${postData.length} > ${jsonLimit}`} };
            targetWindow.postMessage(message, '*');
            return;
        }
        
        
        let prom = ServerRequest.makePollTaskRequest(url, 'POST', postData, this.pollTaskManager, request_id, undefined, this.anonymous);
        
        const serverTimeoutSeconds = 10 * 60; // server has a ten minute timeout
        if (timeLimitSeconds && (timeLimitSeconds < serverTimeoutSeconds)) {
            console.log(`chatbot request ${request_id} using a timeout of ${timeLimitSeconds} seconds`); // FIXME
            prom = prom.timeout(timeLimitSeconds * 1000);
        }
        
        prom.then(({textResponse, messageHistory})=>{
            //console.log(textResponse);
            let message = { type: type, data: {request_id, chatbotResponse:textResponse, messageHistory} };
            targetWindow.postMessage(message, '*');
        })
        .catch((err)=>{
            console.log(err);
            if (err && (err.name === 'TimeoutError')) { // if ( err instanceof Promise.TimeoutError) {
                console.log(`chatbot request ${request_id} timed out ( after ${timeLimitSeconds} seconds)`); // FIXME
                this.pollTaskManager.cancelAction(request_id);
            }

            let error_text = "Error";
            if (typeof err === 'object') {
                error_text = err.message || err.responseText;
                if (!error_text) {
                    console.log("failed to get error text from error",err); // FIXME
                    error_text = err.toString()
                }
            }
            
            
            let message = { type: MESSAGE_TYPES.chatbot_error, data: {request_id, error:error_text} };
            targetWindow.postMessage(message, '*');
        });
    } // _handleChatbotRequest
    
    _handleBoilerplateRequest(targetWindow, msg) {
        if (!targetWindow) {
            console.error("ChatbotSystem needs target window");
            return;
        }
        
        this.targetWindow = targetWindow;
        let {request_id, template_key, version, playbooks, onlyPlaybookStrings } = msg.data;
        if (!version) {
            version = '1.0.0';
            console.log(`warning: get boilerplate defaulting to version ${version}`);
        }
        if (!this.hasPermission) {
            let message = { type: MESSAGE_TYPES.chatbot_template_boilerplate, data: {request_id, error:new Error("not allowed")} };
            targetWindow.postMessage(message, '*');
            return;
        }
        
        let base = this.anonymous ? 'template_boilerplate_anon' : 'template_boilerplate';
        let body = {
            appKey: template_key,
            version,
            playbooks,
            onlyPlaybookStrings,
        }
        
        let url = `/authoring/${base}`;
        ServerRequest.makeRequest(url, 'POST', JSON.stringify(body))
        .then((template_boilerplate)=>{
            let message = { type: MESSAGE_TYPES.chatbot_template_boilerplate, data: {request_id, template_boilerplate } };
            targetWindow.postMessage(message, '*');
        })
        .catch((err)=>{
            console.log(err);
            let message = { type: MESSAGE_TYPES.chatbot_template_boilerplate, data: {request_id, error:new Error("failed to get boilerplate")} };
            targetWindow.postMessage(message, '*');
        });
    } // _handleBoilerplateRequest
    
    _handleSetBoilerplateValueRequest(targetWindow, msg) {
        if (!targetWindow) {
            console.error("ChatbotSystem needs target window");
            return;
        }
        this.targetWindow = targetWindow;
        let {request_id, template_key, version, string_id, string_value} = msg.data;
        if (!version) {
            version = '1.0.0';
            console.log(`warning: set boilerplate defaulting to version ${version}`);
        }

        if (!this.hasPermission) {
            let message = { type: MESSAGE_TYPES.chatbot_set_template_boilerplate_value_result, data: {request_id, error:new Error("not allowed")} };
            targetWindow.postMessage(message, '*');
            return;
        }
        if (!template_key || !version || !string_id) {
            let message = { type: MESSAGE_TYPES.chatbot_set_template_boilerplate_value_result, 
                data: {
                    request_id, 
                    error:new Error(`missing parameter(s): template_key: ${template_key}, version: ${version}, string_id: ${string_id}`)
                }
            };
            targetWindow.postMessage(msg, '*');
            return;
        }
        const data = {
            template_key, version, string_id, string_value, 
            usageData: this.usageData, // in case we want to know, or need it to validate permissions
        };
        
        let url = `/authoring/template_boilerplate/${template_key}`;
        ServerRequest.makeRequest(url, 'PUT', JSON.stringify(data))
        .then((template_boilerplate)=>{
            let message = { type: MESSAGE_TYPES.chatbot_set_template_boilerplate_value_result, data: {request_id, template_boilerplate } };
            targetWindow.postMessage(message, '*');
        })
        .catch((err)=>{
            console.log(err);
            let message = { type: MESSAGE_TYPES.chatbot_set_template_boilerplate_value_result, data: {request_id, error:new Error("failed to set template boilerplate")} };
            targetWindow.postMessage(message, '*');
        });
    } // _handleSetBoilerplateValueRequest

    _handlePlaybookRequest(targetWindow, msg) {
        if (!targetWindow) {
            console.error("ChatbotSystem needs target window");
            return;
        }
        
        this.targetWindow = targetWindow;
        let {request_id, template_key} = msg.data;
        if (!this.hasPermission) {
            let message = { type: MESSAGE_TYPES.chatbot_latest_playbooks, data: {request_id, error:new Error("not allowed")} };
            targetWindow.postMessage(message, '*');
            return;
        }
        
        let base = this.anonymous ? 'latest_ai_playbooks_anon' : 'latest_ai_playbooks';
        let url = `/authoring/${base}/${template_key}`;
        ServerRequest.makeRequest(url, 'GET')
        .then((playbooks)=>{
            let message = { type: MESSAGE_TYPES.chatbot_latest_playbooks, data: {request_id, playbooks } };
            targetWindow.postMessage(message, '*');
        })
        .catch((err)=>{
            console.log(err);
            let message = { type: MESSAGE_TYPES.chatbot_latest_playbooks, data: {request_id, error:new Error("failed to get latest playbooks")} };
            targetWindow.postMessage(message, '*');
        });
    } // _handlePlaybookRequest

    _handleCreatePlaybook(targetWindow, msg) {
        if (!targetWindow) {
            console.error("ChatbotSystem needs target window");
            return;
        }
        
        this.targetWindow = targetWindow;
        let {request_id, template_key, playbook} = msg.data;
        if (!this.hasPermission) {
            let message = { type: MESSAGE_TYPES.chatbot_create_playbook, data: {request_id, error:new Error("not allowed")} };
            targetWindow.postMessage(message, '*');
            return;
        }
        
        let data = {
            appKey: template_key,
            playbook
        };
        ServerRequest.makeRequest(`/authoring/create_ai_playbook`, 'POST', JSON.stringify(data))
        .then((createResult)=>{
            let message = { type: MESSAGE_TYPES.chatbot_create_playbook, data: {request_id, response: createResult } };
            targetWindow.postMessage(message, '*');
        })
        .catch((err)=>{
            console.log(err);
            let message = { type: MESSAGE_TYPES.chatbot_create_playbook, data: {request_id, error:new Error("failed to add playbook")} };
            targetWindow.postMessage(message, '*');
        });
    } // _handleCreatePlaybook

    _handlePublishPlaybook(targetWindow, msg) {
        if (!targetWindow) {
            console.error("ChatbotSystem needs target window");
            return;
        }
        
        let responseType = msg.type;
        
        this.targetWindow = targetWindow;
        let {request_id, template_key, playbook, unpublished_strings } = msg.data;
        if (!this.hasPermission) {
            let message = { type: responseType, data: {request_id, error:new Error("not allowed")} };
            targetWindow.postMessage(message, '*');
            return;
        }
        
        let data = {
            appKey: template_key,
            playbook,
            unpublished_strings, // these are compared with the server string. If there are any differences, publish attempt is rejected
        };
        ServerRequest.makeRequest(`/authoring/publish_ai_playbook`, 'POST', JSON.stringify(data))
        .then((createResult)=>{
            let message = { type: responseType, data: {request_id, response: createResult } };
            targetWindow.postMessage(message, '*');
        })
        .catch((err)=>{
            console.log("publish_ai_playbook error:",err);
            let error_message = err.message || err.responseText || "failed to publish playbook";
            let message = { type: responseType, data: {request_id, error: error_message} };
            targetWindow.postMessage(message, '*');
        });
    } // _handlePublishPlaybook

    _handleUpdatePlaybookStringKey(targetWindow,msg) {
        if (!targetWindow) {
            console.error("ChatbotSystem needs target window");
            return;
        }
        
        let responseType = msg.type;
        
        this.targetWindow = targetWindow;
        let {request_id, template_key, playbook, string_id, version } = msg.data;
        if (!this.hasPermission) {
            let message = { type: responseType, data: {request_id, error:new Error("not allowed")} };
            targetWindow.postMessage(message, '*');
            return;
        }
        
        let data = {
            appKey: template_key,
            playbook, string_id, version,
        };
        ServerRequest.makeRequest(`/authoring/update_ai_playbook_string_key`, 'POST', JSON.stringify(data))
        .then((updatedPlaybook)=>{
            let message = { type: responseType, data: {request_id, response: updatedPlaybook } };
            targetWindow.postMessage(message, '*');
        })
        .catch((err)=>{
            console.log("update_ai_playbook_string_key error:",err);
            let error_message = err.message || err.responseText || "failed to update string_key";
            let message = { type: responseType, data: {request_id, error: error_message} };
            targetWindow.postMessage(message, '*');
        });
    } // _handleUpdatePlaybookStringKey

    _handleUpdatePlaybookStringKeys(targetWindow, msg) {
        if (!targetWindow) {
            console.error("ChatbotSystem needs target window");
            return;
        }
        
        let responseType = msg.type;
        
        this.targetWindow = targetWindow;
        let {request_id, template_key, playbook, string_keys } = msg.data;
        if (!this.hasPermission) {
            let message = { type: responseType, data: {request_id, error:new Error("not allowed")} };
            targetWindow.postMessage(message, '*');
            return;
        }
        
        let data = {
            appKey: template_key,
            playbook, string_keys,
        };
        ServerRequest.makeRequest(`/authoring/update_ai_playbook_string_keys`, 'POST', JSON.stringify(data))
        .then((updatedPlaybook)=>{
            let message = { type: responseType, data: {request_id, response: updatedPlaybook } };
            targetWindow.postMessage(message, '*');
        })
        .catch((err)=>{
            console.log("update_ai_playbook_string_keys error:",err);
            let error_message = err.message || err.responseText || "failed to update string_keys";
            let message = { type: responseType, data: {request_id, error: error_message} };
            targetWindow.postMessage(message, '*');
        });
    } // _handleUpdatePlaybookStringKeys


    _handleUpdatePlaybookModels(targetWindow, msg) {
        if (!targetWindow) {
            console.error("ChatbotSystem needs target window");
            return;
        }
        
        let responseType = msg.type;
        
        this.targetWindow = targetWindow;
        let {request_id, template_key, playbook, model_ids, image_model_id } = msg.data;
        if (!this.hasPermission) {
            let message = { type: responseType, data: {request_id, error:new Error("not allowed")} };
            targetWindow.postMessage(message, '*');
            return;
        }
        
        let data = {
            appKey: template_key,
            playbook, model_ids, image_model_id,
        };
        ServerRequest.makeRequest(`/authoring/update_ai_playbook_models`, 'POST', JSON.stringify(data))
        .then((updatedPlaybook)=>{
            let message = { type: responseType, data: {request_id, response: updatedPlaybook } };
            targetWindow.postMessage(message, '*');
        })
        .catch((err)=>{
            console.log("update_ai_playbook_models error:",err);
            let error_message = err.message || err.responseText || "failed to update string_key";
            let message = { type: responseType, data: {request_id, error: error_message} };
            targetWindow.postMessage(message, '*');
        });
    } // _handleUpdatePlaybookModels

    _handleImageGenRequest(targetWindow, msg) {
        if (!targetWindow) {
            console.error("ImageGenSystem needs target window");
            return;
        }

        this.targetWindow = targetWindow;
        let { request_id, prompt, modelId, modelParameters, useCase, timeLimitSeconds } = msg.data;

        if (!this.hasPermission) {
            var errMsg = { type: MESSAGE_TYPES.img_gen_error, data: { request_id, error: new Error("not allowed") } };
            targetWindow.postMessage(errMsg, '*');
            return;
        }

        if (useCase && !modelParameters) {
            // determine model parameters depending on use case
            modelParameters = _.find(this.modelParamCases,{useCase});
            if (!modelParameters) {
                console.log(`Error: Did not find useCase: ${useCase}`);
            }
        }
        
        if (!_.includes(AVAILABLE_IMG_MODEL_IDS,modelId)) {
            if (modelId) {
                console.error(`modelId ${modelId} not listed in AVAILABLE_IMG_MODEL_IDS.  Using default instead.`);
            }
            modelId = DEFAULT_IMG_MODEL_ID;
        } 

        let data = {
            imgPrompt: prompt,
            modelId, 
            modelParameters,
            usageData: this.usageData
        };

        let url = this.anonymous ? `/authoring/generate_image_anon` : `/authoring/generate_image`;

        let prom = ServerRequest.makePollTaskRequest(url, 'POST', JSON.stringify(data), this.pollTaskManager, request_id, undefined, this.anonymous);

        const serverTimeoutSeconds = 10 * 60; // server has a ten minute timeout
        if (timeLimitSeconds && (timeLimitSeconds < serverTimeoutSeconds)) {
            console.log(`Image gen request ${request_id} using a timeout of ${timeLimitSeconds} seconds`); // FIXME
            prom = prom.timeout(timeLimitSeconds * 1000);
        }

        prom.then((response) => {
            const message = { type: MESSAGE_TYPES.img_gen_result, data: { request_id, images: response.images, error: response.error } };
            targetWindow.postMessage(message, '*');
        })
        .catch((err) => {
            console.log(err);
            if (err && (err.name === 'TimeoutError')) { // if ( err instanceof Promise.TimeoutError) {
                console.log(`Image gen request ${request_id} timed out ( after ${timeLimitSeconds} seconds)`); // FIXME
                this.pollTaskManager.cancelAction(request_id);
            }

            console.error("Image gen error:", err);

            const errMsg = {
                type: MESSAGE_TYPES.img_gen_error,
                data: { request_id, error: err.message || "Image generation failed" }
            };
            targetWindow.postMessage(errMsg, '*');
        });
    } // _handleImageGenRequest

    _handleAgentRequest(targetWindow, msg) {
        if (!targetWindow) {
            console.error("AgentSystem needs target window");
            return;
        }
        
        //checkAwsStickyCookie(); // TEST
        
        this.targetWindow = targetWindow;
        let {request_id, sessionId, systemText, userInput, priorHistory, modelId, imgModelId, modelParameters, useCase, timeLimitSeconds, template_key, string_keys} = msg.data;

        if (!this.hasPermission) {
            const message = { type: MESSAGE_TYPES.agent_error, data: {request_id, error:new Error("not allowed")} };
            targetWindow.postMessage(message, '*');
            return;
        }

        if (useCase && !modelParameters) {
            // determine model parameters depending on use case
            modelParameters = _.find(this.modelParamCases,{useCase});
            if (modelParameters) {
                console.log(`Using modelParameters based on useCase: ${JSON.stringify(modelParameters)}`); // FIXME: remove debug spam
            }
            else {
                console.log(`Error: Did not find useCase: ${useCase}`);
            }
        }
        else if (modelParameters) {
            console.log(`Using specified modelParameters: ${JSON.stringify(modelParameters)}`); // FIXME: remove debug spam
        }
        
        if (!_.includes(AVAILABLE_MODEL_IDS,modelId)) {
            if (modelId) {
                console.error(`modelId ${modelId} not listed in AVAILABLE_MODEL_IDS.  Using default instead.`);
            }
            modelId = DEFAULT_MODEL_ID;
        }
        
        if (!_.includes(AVAILABLE_IMG_MODEL_IDS,imgModelId)) {
            if (imgModelId) {
                console.error(`imgModelId ${imgModelId} not listed in AVAILABLE_IMG_MODEL_IDS.  Using default instead.`);
            }
            imgModelId = DEFAULT_IMG_MODEL_ID;
        } 
        
        let agentState = { sessionId, systemText, textFromUser:userInput, messageHistory:priorHistory, imgModelId, modelId, modelParameters, appKey:template_key, string_keys };
        let type = MESSAGE_TYPES.agent_result;
        
        let data = {...agentState, 
            usageData: this.usageData
        };
        //let url = this.anonymous ? `/authoring/interactive_agent_anon` : `/authoring/interactive_agent`;

        if (this.anonymous) {
            console.error("anonymous agent calls disabled. Please log in");
            return;
        }

        let url = `/authoring/interactive_agent`;
        let postData = JSON.stringify(data);
        let jsonLimit = GlobalConfig.jsonUploadLimit || 1024*1024; // GlobalConfig.jsonUploadLimit doesn't currently exist, but nova-nodejs sets jsonBodyParser.limit to "1mb"
        if (postData.length > jsonLimit) {
            let message = { type: MESSAGE_TYPES.agent_error, data: {request_id, error: `payload length exceeds limit.  ${postData.length} > ${jsonLimit}`} };
            targetWindow.postMessage(message, '*');
            return;
        }
        
        
        let prom = ServerRequest.makePollTaskRequest(url, 'POST', postData, this.pollTaskManager, request_id, undefined, this.anonymous);
        
        const serverTimeoutSeconds = 10 * 60; // server has a ten minute timeout
        if (timeLimitSeconds && (timeLimitSeconds < serverTimeoutSeconds)) {
            console.log(`agent request ${request_id} using a timeout of ${timeLimitSeconds} seconds`); // FIXME
            prom = prom.timeout(timeLimitSeconds * 1000);
        }
        
        prom.then(({textResponse, messageHistory, agentTrace, activeSessionId})=>{
            //console.log(textResponse);
            let message = { type: type, data: {request_id, sessionId:activeSessionId, agentResponse:textResponse, messageHistory, agentTrace} };
            targetWindow.postMessage(message, '*');
        })
        .catch((err)=>{
            console.log(err);
            if (err && (err.name === 'TimeoutError')) { // if ( err instanceof Promise.TimeoutError) {
                console.log(`agent request ${request_id} timed out ( after ${timeLimitSeconds} seconds)`); // FIXME
                this.pollTaskManager.cancelAction(request_id);
            }

            let error_text = "Error";
            if (typeof err === 'object') {
                error_text = err.message || err.responseText;
                if (!error_text) {
                    console.log("failed to get error text from error",err); // FIXME
                    error_text = err.toString()
                }
            }

            // agentTrace (which agents were called, and how long each took, before the
            // failure) is attached to the error object by interactiveAgent when the
            // orchestrator itself reported it - forward it so the caller can see what ran.
            let agentTrace = (err && typeof err === 'object') ? err.agentTrace : undefined;

            let message = { type: MESSAGE_TYPES.agent_error, data: {request_id, error:error_text, agentTrace} };
            targetWindow.postMessage(message, '*');
        });
    } // _handleAgentRequest


    handleMessage(msg, targetWindow) {
        switch(msg.type) {
            case MESSAGE_TYPES.chatbot_request: 
                //console.log("ChatbotSystem handling message",msg);
                this._handleChatbotRequest(targetWindow, msg);
                return true;
                
            case MESSAGE_TYPES.chatbot_get_template_boilerplate:
                this._handleBoilerplateRequest(targetWindow, msg);
                return true;
                
            case MESSAGE_TYPES.chatbot_get_available_models:
            {
                if (!targetWindow) {
                    console.error("ChatbotSystem needs target window");
                    return;
                }
                this.targetWindow = targetWindow;
                let message = { type: MESSAGE_TYPES.chatbot_available_models, data: AVAILABLE_MODEL_IDS, default_model_id: DEFAULT_MODEL_ID };
                // console.log("chatbot_get_available_models response:", message); // FIXME: remove debug spam
                targetWindow.postMessage(message, '*');
                return true;
            }
            
            case MESSAGE_TYPES.chatbot_set_template_boilerplate_value:
                this._handleSetBoilerplateValueRequest(targetWindow, msg);
                return true;

            case MESSAGE_TYPES.chatbot_get_latest_playbooks:
                this._handlePlaybookRequest(targetWindow, msg);
                return true;
                
            case MESSAGE_TYPES.chatbot_create_playbook:
                this._handleCreatePlaybook(targetWindow, msg);
                return true;
                
            case MESSAGE_TYPES.chatbot_publish_playbook:
                this._handlePublishPlaybook(targetWindow, msg);
                return true;

            case MESSAGE_TYPES.chatbot_update_playbook_string_key:
                this._handleUpdatePlaybookStringKey(targetWindow, msg);
                return true;
                
            case MESSAGE_TYPES.chatbot_update_playbook_string_keys:
                this._handleUpdatePlaybookStringKeys(targetWindow, msg);
                return true;
            
            case MESSAGE_TYPES.chatbot_update_playbook_models:
                this._handleUpdatePlaybookModels(targetWindow, msg);
                return true;

            case MESSAGE_TYPES.img_gen_request:
                this._handleImageGenRequest(targetWindow, msg);
                return true;

            case MESSAGE_TYPES.img_gen_get_available_models:
            {
                if (!targetWindow) {
                    console.error("ChatbotSystem needs target window");
                    return;
                }
                this.targetWindow = targetWindow;
                let message = { type: MESSAGE_TYPES.img_gen_available_models, data: AVAILABLE_IMG_MODEL_IDS, default_model_id: DEFAULT_IMG_MODEL_ID };
                targetWindow.postMessage(message, '*');
                return true;
            }

        case MESSAGE_TYPES.agent_request: 
                this._handleAgentRequest(targetWindow, msg);
                return true;
        }
        return false;
    }
    
    shutDown() {
        delete this.targetWindow;
        this.pollTaskManager.abandonTasks();
        this.unsubscribes.forEach(u => u());
        if (this.dataTimer) {
            clearTimeout(this.dataTimer);
            delete this.dataTimer;
        }
    }

};

ChatbotSystem.MESSAGE_TYPES = MESSAGE_TYPES; // outgoing message types

ChatbotSystem.DEFAULT_MODEL_ID = DEFAULT_MODEL_ID;
ChatbotSystem.AVAILABLE_MODEL_IDS = AVAILABLE_MODEL_IDS;

ChatbotSystem.DEFAULT_IMG_MODEL_ID = DEFAULT_IMG_MODEL_ID;
ChatbotSystem.AVAILABLE_IMG_MODEL_IDS = AVAILABLE_IMG_MODEL_IDS;

ChatbotSystem.SYSTEM_USAGE = Globals.SYSTEM_USAGE; // alias
ChatbotSystem.USE_CASES = Globals.ai.useCases; // for selecting which set of model parameters (based on use case and possible per-organization customization)

module.exports = ChatbotSystem;